module.exports = __webpack_public_path__ + "img/V5-bg.7fa185af.png";